{
    "name": "dark-ansi",
    "primary": "#5555ff",
    "secondary": "#ff55ff",
    "success": "#55ff55",
    "error": "#ff5555",
    "warning": "#ffff55",
    "text": "#ffffff",
    "textDim": "#aaaaaa",
    "textMuted": "#aaaaaa",
    "secondaryText": "#aaaaaa",
    "border": "#555555",
    "background": "",
    "accent": "#5555ff",
    "toolName": "#5555ff",
    "toolSuccess": "#55ff55",
    "toolError": "#ff5555",
    "diffAdded": "#55ff55",
    "diffRemoved": "#ff5555",
    "diffContext": "#aaaaaa",
    "diffAddedDimmed": "#55ff55",
    "diffRemovedDimmed": "#ff5555",
    "diffAddedWord": "#55ff55",
    "diffRemovedWord": "#ff5555",
    "diffAddedWordDimmed": "#55ff55",
    "diffRemovedWordDimmed": "#ff5555",
    "diffAddedBackground": "#005500",
    "diffAddedBackgroundText": "#ffffff",
    "diffAddedBackgroundWord": "#55ff55",
    "diffRemovedBackground": "#550000",
    "diffRemovedBackgroundText": "#ffffff",
    "diffRemovedBackgroundWord": "#ff5555",
    "spinnerColor": "#5555ff",
    "claude": "#ff5555",
    "claudeShimmer": "#ff5555",
    "permission": "#5555ff",
    "permissionShimmer": "#5555ff",
    "inputPrompt": "#5555ff",
    "footerText": "#aaaaaa",
    "commandColor": "#ff55ff",
    "planPrimary": "#ffff55",
    "planBorder": "#ffff55",
    "subtle": "#555555",
    "link": "#5555ff",
    "code": "#ffff55",
    "subagent1": "#ff5555",
    "subagent2": "#5555ff",
    "subagent3": "#55ff55",
    "subagent4": "#ffff55",
    "subagent5": "#ff55ff",
    "subagent6": "#ff5555",
    "subagent7": "#ff55ff",
    "subagent8": "#55ffff",
    "language": "#55ffff"
}
